/**
 * KCIS Intelligence Layer — Admin API client.
 * All endpoints require super_admin; the shared axios admin interceptor
 * attaches the Bearer token automatically.
 */
import axios from "axios";
import { adminAuth } from "@/lib/api";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/intelligence`;
const client = axios.create({ baseURL: BASE });
client.interceptors.request.use((cfg) => {
  const t = adminAuth.getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const intelligenceApi = {
  libraries: () => client.get("/libraries"),
  healthSummary: () => client.get("/libraries/health-summary"),
  list: (lib, params) => client.get(`/${lib}`, { params }),
  read: (lib, slug) => client.get(`/${lib}/${slug}`),
  create: (lib, payload) => client.post(`/${lib}`, payload),
  update: (lib, slug, payload) => client.put(`/${lib}/${slug}`, payload),
  archive: (lib, slug, hard = false) => client.delete(`/${lib}/${slug}`, { params: { hard } }),
  importJson: (lib, payload) => client.post(`/${lib}/import`, payload),
  exportJsonUrl: (lib) => `${BASE}/${lib}/export.json`,
};
